import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import Window from '../dialog/Window'
import ValueGrid from '../widgets/ValueGrid'

import priceUtils from 'utils/price'
import subscriptionUtils from 'utils/subscription'

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}))

const ConfirmSubscriptionChangeWindow = ({
  changeInfo,
  subscription,
  onCancel,
  onConfirm,
}) => {
  const classes = useStyles()
  
  const subscriptionInfo = subscriptionUtils.getSubscriptionInfo(subscription)

  const nextInvoiceItems = changeInfo.current_prorations.concat(changeInfo.next_invoice_items)
  const subsequentInvoiceItems = changeInfo.next_invoice_items

  const nextInvoiceCost = nextInvoiceItems.reduce((all, item) => {
    return all + item.amount
  }, 0)

  const subsequentInvoiceCost = subsequentInvoiceItems.reduce((all, item) => {
    return all + item.amount
  }, 0)

  return (
    <Window
      open
      withCancel
      title="Update Subscription"
      cancelTitle="Close"
      submitTitle="Confirm Change"
      size="md"
      onSubmit={ onConfirm }
      onCancel={ onCancel }
    >
      <Typography gutterBottom>
        You are changing the your plan; your next invoice will include the cost of this change for this month:
      </Typography>
      <div className={ classes.divider }></div>
      <ValueGrid
        raw
        spacing={ 1 }
        titleSize={ 6 }
        data={
          [{
            title: <Divider />,
            value: <Divider />,
          }]
          .concat(
            subscriptionUtils.getProrationTable(changeInfo.current_prorations)
          )
          .concat([{
            title: <Divider />,
            value: <Divider />,
          }])
        }
      />
      <div className={ classes.divider }></div>
      <Typography gutterBottom>
        It will also include the cost of your new plan for the next month:
      </Typography>
      <div className={ classes.divider }></div>
      <ValueGrid
        raw
        spacing={ 1 }
        titleSize={ 6 }
        data={
          [{
            title: <Divider />,
            value: <Divider />,
          }]
          .concat(
            subscriptionUtils.getProrationTable(changeInfo.next_invoice_items)
          )
          .concat([{
            title: <Divider />,
            value: <Divider />,
          }])
        }
      />
      <div className={ classes.divider }></div>
      <Typography gutterBottom>
        Here is a summary of expected costs:
      </Typography>
      <div className={ classes.divider }></div>
      <ValueGrid
        raw
        spacing={ 1 }
        titleSize={ 6 }
        data={
          [{
            title: `Your next invoice (${ subscriptionInfo.periodEnd }):`,
            value: (
              <span>
                <strong>{ subscriptionUtils.CURRENCY }{ priceUtils.displayPrice(nextInvoiceCost) }</strong>
                &nbsp;(includes additional cost or refund for this billing cycle)
              </span>
            ),
          },{
            title: `Subsequent invoices (from ${ subscriptionInfo.nextPeriodStart }):`,
            value: (
              <span>
                <strong>{ subscriptionUtils.CURRENCY }{ priceUtils.displayPrice(subsequentInvoiceCost) }</strong>
                &nbsp;per month
              </span>
            ),
          }]
        }
      />
    </Window>
  )
}

export default ConfirmSubscriptionChangeWindow
